"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const OverclaimConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup/OverclaimConfirmationPopup"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const OverclaimWarningStep = (props) => {
    const { onClickConfirm, onClickCancel } = props;
    return (react_1.default.createElement(Popup_1.default, { onClose: () => { } },
        react_1.default.createElement(OverclaimConfirmationPopup_1.default, { onClickConfirm: onClickConfirm, confirmButtonText: 'Continue', onClickCancel: onClickCancel })));
};
exports.default = OverclaimWarningStep;
